import useInvalidateResources from 'hooks/useInvalidateResources';
import usePusher from 'hooks/usePusher';
import { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { BankTransactionsCacheKeys } from 'types/cacheKeys.types';
import { World } from 'types/shared/worlds';

const useTransactionsUpdateEvent = () => {
  const channel = usePusher();
  const invalidateResources = useInvalidateResources();

  const queryClient = useQueryClient();

  useEffect(() => {
    if (!channel) return;

    const handler = () => {
      invalidateResources(World.BANK);

      queryClient.invalidateQueries(BankTransactionsCacheKeys.StandingOrders);

      queryClient.invalidateQueries(
        BankTransactionsCacheKeys.TransactionsListByStatus,
      );
    };

    channel.bind('transaction.created', handler);
    channel.bind('transaction.updated', handler);

    return () => {
      channel.unbind('transaction.created', handler);
      channel.unbind('transaction.updated', handler);
    };
  }, [channel, invalidateResources, queryClient]);
};

export default useTransactionsUpdateEvent;
